module.exports = __webpack_public_path__ + "static/media/jolnezki.d9e9c85f.png";